import { call, put, takeLatest } from "redux-saga/effects";
import { get } from "lodash";
import { defaultReturn, generateDefaultActions, makePayload, makeWritePayload } from "shared-utility/store/utils/helpers";

import uploadFile from "../../helpers/sourceFileUploadHelper";

const initialState = {
  details: null,
  isUploading: false,
  selectedFile: null,
  sourceId: null,
  uploadErrorMessage: null,
  uploadSuccessful: false
};

// ACTIONS
export const UPLOAD_RENT_ROLL = generateDefaultActions("UPLOAD_RENT_ROLL");
export const upload = (dealId, propertyId, userId, sourceId, typeId, file, isPortfolioLevel, companyId) => makePayload(UPLOAD_RENT_ROLL.value, { dealId, propertyId, userId, sourceId, typeId, file, isPortfolioLevel, companyId });
function* uploadRentRollSaga(payload) {
  try {
    const response = yield call(uploadFile, { ...payload, url: "/rent-rolls/upload" }, "POST");
    yield put({ type: UPLOAD_RENT_ROLL.success, payload: response });
  } catch (error) {
    const userFriendlyError = get(error, "response.data.error", "Upload encountered error. Please choose a different file and try again.");
    yield put({ type: UPLOAD_RENT_ROLL.failure, payload: { userFriendlyError, error } });
  }
}

export const SET_RENT_ROLL_UPLOAD_SELECTIONS = generateDefaultActions("SET_RENT_ROLL_UPLOAD_SELECTIONS");
export const setRentRollUploadSelections = payload => makeWritePayload(SET_RENT_ROLL_UPLOAD_SELECTIONS.value, payload);

export const actionCreators = {
  setRentRollUploadSelections,
  upload
};

// REDUCER
export function uploadRentRollModalReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SET_RENT_ROLL_UPLOAD_SELECTIONS.value:
      return defaultReturn({ ...state, ...payload });

    case UPLOAD_RENT_ROLL.value:
      return { ...state, isUploading: true };
    case UPLOAD_RENT_ROLL.success:
      return { ...state, isUploading: false, uploadErrorMessage: null, uploadSuccessful: true, details: payload.data };
    case UPLOAD_RENT_ROLL.failure:
      return { ...state, isUploading: false, uploadErrorMessage: "Upload failed, please try again", uploadSuccessful: false };

    // DEFAULT
    default:
      return state;
  }
}

// SAGA
export function* uploadRentRollModalSaga() {
  yield takeLatest(UPLOAD_RENT_ROLL.value, uploadRentRollSaga);
}
